module.exports = __webpack_public_path__ + "img/3c01e0b.jpg";